module.exports = __webpack_public_path__ + "static/sparrow-zoom-7cf50fb5265bb9175535e13ecbe47586.jpg";